import apiInstance from '../utils/axiosConfig';

const ContractService = {
    // Générer un PDF de contrat
    generateContractPdf: async (id) => {
        try {
            const response = await apiInstance.get(`/contracts/generateContractPdf/${id}`, {
                responseType: 'arraybuffer'
            });
            return response.data;
        } catch (error) {
            console.error('Error generating contract PDF:', error);
            throw error;
        }
    },

    // Créer un contrat
    createContract: async (contractRequestDTO) => {
        try {
            const response = await apiInstance.post('/contracts/createContract', contractRequestDTO);
            return response.data;
        } catch (error) {
            console.error('Error creating contract:', error.message || error);
            throw error;
        }
    },

    // ==================== SIGNATURES ====================

    // Signature par le client
    signByClient: async (id, username, signedPdf) => {
        try {
            const formData = new FormData();
            formData.append('username', username);
            formData.append('signedPdf', signedPdf);

            const response = await apiInstance.post(
                `/contracts/sign-by-client/${id}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error signing contract by client:', error.message || error);
            throw error;
        }
    },

    // Signature par l'admin
    signByAdmin: async (id, username, signedPdf) => {
        try {
            const formData = new FormData();
            formData.append('username', username);
            formData.append('signedPdf', signedPdf);

            const response = await apiInstance.post(
                `/contracts/sign-by-admin/${id}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error signing contract by admin:', error.message || error);
            throw error;
        }
    },

    // ==================== RÉCUPÉRATION ====================

    // Récupérer un contrat par ID
    getContractById: async (id) => {
        try {
            const response = await apiInstance.get(`/contracts/getContractById/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching contract by id:', error.message || error);
            throw error;
        }
    },

    // Récupérer tous les contrats
    getAllContracts: async () => {
        try {
            const response = await apiInstance.get('/contracts/getAllContracts');
            return response.data;
        } catch (error) {
            console.error('Error fetching all contracts:', error.message || error);
            throw error;
        }
    },

    // Récupérer les contrats par ID de client
    getContractsByClientId: async (clientId) => {
        try {
            const response = await apiInstance.get(`/contracts/getContractsByClientId/${clientId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching contracts by client id:', error.message || error);
            throw error;
        }
    },

    // Récupérer les contrats par ID de professionnel
    getContractsByProfessionalId: async (professionalId) => {
        try {
            const response = await apiInstance.get(`/contracts/getContractsByProfessionalId/${professionalId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching contracts by professional id:', error.message || error);
            throw error;
        }
    },

    // Récupérer un contrat par ID de client EOI
    getContractByClientEOIId: async (clientEOIId) => {
        try {
            const response = await apiInstance.get(`/contracts/getContractByClientEOIId/${clientEOIId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching contract by client EOI id:', error.message || error);
            throw error;
        }
    },

    // Mettre à jour un contrat
    updateContract: async (id, contractRequestDTO) => {
        try {
            const response = await apiInstance.put(`/contracts/updateContract/${id}`, contractRequestDTO);
            return response.data;
        } catch (error) {
            console.error('Error updating contract:', error.message || error);
            throw error;
        }
    },

    // Supprimer un contrat
    deleteContract: async (id) => {
        try {
            await apiInstance.delete(`/contracts/deleteContract/${id}`);
        } catch (error) {
            console.error('Error deleting contract:', error.message || error);
            throw error;
        }
    },
};

export default ContractService;